import React from "react";

const why = [
  ["Identify Earlier", "Create a consistent method for reviewing approved emerging-risk indicators."],
  ["Prioritize Resources", "Use structured tiers to help organize review and intervention capacity."],
  ["Standardize Engagement", "Give teams approved, adaptable communication and intervention resources."],
  ["Document the Process", "Create a consistent record from identification through resolution."],
  ["Measure Outcomes", "Track contacts, evaluations, resolutions, roll rates, cures, complaints, and other institution-approved KPIs."],
  ["Build the Business Case", "Use the institution's own historical costs and portfolio economics rather than a generic savings claim."],
];

const bcFactors = ["portfolio size", "historical roll rates", "cure rates", "loss severity", "foreclosure costs", "operating costs", "intervention population", "intervention assumptions", "modification / resolution outcomes", "residual expected loss"];

const previewItems = ["Executive overview", "Complete table of contents", "Sample borrower analysis", "Framework architecture overview", "Governance / compliance architecture overview", "Market-data source documentation"];

const BusinessPreview = () => (
  <>
    {/* WHY BUY */}
    <section className="section bg1">
      <div className="w">
        <div style={{ maxWidth: 760 }}>
          <div className="eyebrow">Why Servicing Leaders Use It</div>
          <h2 className="h2">Why Servicing Leaders Would <em className="gold">Use the Playbook</em></h2>
        </div>
        <div className="why-grid">
          {why.map((w, i) => (<div className="why-item" key={i}><h4>{w[0]}</h4><p>{w[1]}</p></div>))}
        </div>
      </div>
    </section>

    {/* WHAT YOU'RE BUYING */}
    <section className="section bg2">
      <div className="w">
        <div className="buy-statement">
          <div className="big">You're Not Buying a Report.<br />You're Licensing a Complete <em>Institutional Implementation Framework.</em></div>
          <p>The Mortgage Survival Playbook includes the methodology, operating protocols, communication assets, borrower case studies, implementation roadmap, governance resources, dashboards, KPI framework, business-case model, and executive presentation needed for an institution to evaluate and adapt the framework internally.</p>
        </div>
      </div>
    </section>

    {/* BUSINESS CASE */}
    <section id="business" className="section bg1">
      <div className="wm">
        <div className="eyebrow">Institution-Controlled Business Case</div>
        <h2 className="h2">Build the Business Case Using Your Own <em className="gold">Portfolio Economics.</em></h2>
        <p className="lead">The $4,995 license price is known. The potential portfolio benefit is not. Each institution should evaluate the framework using its own:</p>
        <div className="compliance-strip" style={{ marginTop: "1.2rem" }}>
          {bcFactors.map((f, i) => (<div className="cb" key={i}>{f}</div>))}
        </div>
        <p className="lead">The Playbook provides the structure for management to build its own scenario.</p>
        <p className="md-note">Actual financial outcomes vary by portfolio, execution, borrower circumstances, investor requirements, market conditions, and institutional decisions. No specific ROI or savings is promised.</p>
      </div>
    </section>

    {/* PREVIEW */}
    <section id="preview" className="section bg2">
      <div className="wm">
        <div className="eyebrow">Evaluate Before You License</div>
        <h2 className="h2">Request the Institutional <em className="gold">Preview</em></h2>
        <p className="lead">You will receive:</p>
        <div style={{ marginTop: "1.2rem", maxWidth: 620 }}>
          {previewItems.map((p, i) => (<div className="result-tick" key={i}><span>{p}</span></div>))}
        </div>
        <p className="md-note">The preview is designed to demonstrate the framework without disclosing the complete proprietary scoring methodology, intervention protocols, scripts, and implementation system contained in the licensed Playbook.</p>
        <a className="btn-gold" href="mailto:hello@mortgagesurvivalplaybook.com?subject=Institutional%20Preview%20Request&body=Please%20send%20the%20institutional%20preview.%0A%0AName%3A%0AInstitution%3A%0ARole%3A">Request Free Institutional Preview</a>
        <p style={{ fontSize: "0.82rem", color: "var(--g3)", marginTop: "1rem" }}>No mailing list required. No sales call unless requested.</p>
      </div>
    </section>
  </>
);

export default BusinessPreview;
